/**
 * documentation at
 * https://webartelier.de/fee_doc/list_classes.html#accordion
 */


class Accordion {

  static init = (params) => {
    const selAccordion = `${params.selAccordion}:not(.is-initialized)`;
    const allAccordions = document.querySelectorAll(selAccordion);

    allAccordions.forEach(accordion => {
      new Accordion(accordion, params);
    })
  }



  constructor(accordion, params) {
    this.accordion = accordion;
    this.selTitle = params.selTitle;
    this.selContent = params.selContent;
    this.itemsMap = new Map();
    this.getCssCustomProperty = params.getCssCustomProperty;
    this.isOpenSingle = this.accordion.dataset.type === 'openSingle';
    this.animationDelay = 0;

    this.markInitialized();
    this.getAnimationDelay();
    this.createItemsMap();
    this.makeAccessible();
    this.startListening();
  }



  markInitialized = () => {
    this.accordion.classList.add('is-initialized');
  }



  getAnimationDelay = () => {
    const scope = document.body;
    const delay = this.getCssCustomProperty(scope, '--an-duration');
    const delayUnitless = parseFloat(delay.replace('s', ''));
    const delayInMs = delayUnitless * 1000;

    this.animationDelay = delayInMs;
  }



  createItemsMap = () => {
    const allTitles = this.accordion.querySelectorAll(this.selTitle);

    allTitles.forEach(title => {
      const contentID = title.dataset.content;
      const content = this.accordion.querySelector(`#${contentID}`);
      this.itemsMap.set(title, content);
    })
  }



  makeAccessible = () => {
    this.itemsMap.forEach((content, title) => {
      title.tabIndex = 0;
    })
  }



  startListening = () => {
    this.accordion.addEventListener('click', (e) => {
      const clickedAccordionTitle = this.itemsMap.get(e.target);
      if (clickedAccordionTitle) this.setItemState(e.target);
    });

    this.accordion.addEventListener('keyup', this.checkKey);
  }



  setItemState = (title) => {
    const hasClickedOnOpenSingleItem =
      this.isOpenSingle && title.classList.contains('is-active');

    if (hasClickedOnOpenSingleItem) {
      this.closeCurrentItem(title);
      return;
    }

    if (this.isOpenSingle) this.closeAllItems();
    this.toggleItem(title);
    this.scrollActiveItemIntoView(title);
  }



  checkKey = (e) => {
    e.preventDefault();
    
    switch (e.code) {
      default:
        return
      case 'Space':
        this.setItemState(e.target)
    }
  }



  toggleItem = (title) => {
    const content = this.itemsMap.get(title);
    content.ariaExpanded = content.ariaExpanded !== 'true';
    content.classList.toggle('is-open');
    title.classList.toggle('is-active');
  }



  scrollActiveItemIntoView = (title) => {
    setTimeout(() => { title.scrollIntoView() }, this.animationDelay);
  }



  closeCurrentItem = (title) => {
    const content = this.itemsMap.get(title);
    content.ariaExpanded = 'false';
    title.classList.remove('is-active');
    content.classList.remove('is-open');
  }



  closeAllItems = () => {
    this.itemsMap.forEach((content, title) => {
      content.ariaExpanded = 'false';
      title.classList.remove('is-active');
      content.classList.remove('is-open');
    })
  }
}
